var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#373A3C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4067_25370)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2061,
    transform: "translate(-774 -1027)",
    fill: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -674,
    y: -567,
    width: 1320,
    height: 1571,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4067_25370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-654 -144C-654 -149.523 -649.523 -154 -644 -154H616C621.523 -154 626 -149.523 626 -144V156C626 161.523 621.523 166 616 166H-644C-649.523 166 -654 161.523 -654 156V-144Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-654 -144C-654 -149.523 -649.523 -154 -644 -154H616C621.523 -154 626 -149.523 626 -144V156C626 161.523 621.523 166 616 166H-644C-649.523 166 -654 161.523 -654 156V-144Z",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -168,
    y: -58,
    width: 190,
    height: 76.0001,
    rx: 10,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 6,
    fill: "#31435B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26471 4.94118C3.18824 4.94118 3.12506 4.91612 3.07518 4.866C3.02506 4.81612 3 4.75294 3 4.67647V3.31765C3 3.22941 3.03094 3.15435 3.09282 3.09247C3.15447 3.03082 3.22941 3 3.31765 3H4.67647C4.75294 3 4.81624 3.02494 4.86635 3.07482C4.91624 3.12494 4.94118 3.18824 4.94118 3.26471C4.94118 3.34118 4.91624 3.40435 4.86635 3.45424C4.81624 3.50435 4.75294 3.52941 4.67647 3.52941H3.9L4.90588 4.53529C4.95294 4.58235 4.97647 4.64118 4.97647 4.71176C4.97647 4.78235 4.95 4.84412 4.89706 4.89706C4.84412 4.95 4.78235 4.97647 4.71176 4.97647C4.64118 4.97647 4.57941 4.95 4.52647 4.89706L3.52941 3.9V4.67647C3.52941 4.75294 3.50435 4.81612 3.45424 4.866C3.40435 4.91612 3.34118 4.94118 3.26471 4.94118ZM7.10294 4.89706C7.05 4.84412 7.02353 4.78235 7.02353 4.71176C7.02353 4.64118 7.05 4.57941 7.10294 4.52647L8.1 3.52941H7.32353C7.24706 3.52941 7.18388 3.50435 7.134 3.45424C7.08388 3.40435 7.05882 3.34118 7.05882 3.26471C7.05882 3.18824 7.08388 3.12494 7.134 3.07482C7.18388 3.02494 7.24706 3 7.32353 3H8.68235C8.77059 3 8.84565 3.03082 8.90753 3.09247C8.96918 3.15435 9 3.22941 9 3.31765V4.67647C9 4.75294 8.97506 4.81612 8.92518 4.866C8.87506 4.91612 8.81176 4.94118 8.73529 4.94118C8.65882 4.94118 8.59553 4.91612 8.54541 4.866C8.49553 4.81612 8.47059 4.75294 8.47059 4.67647V3.9L7.46471 4.90588C7.41765 4.95294 7.35882 4.97647 7.28824 4.97647C7.21765 4.97647 7.15588 4.95 7.10294 4.89706ZM7.32353 9C7.24706 9 7.18388 8.97506 7.134 8.92518C7.08388 8.87506 7.05882 8.81176 7.05882 8.73529C7.05882 8.65882 7.08388 8.59553 7.134 8.54541C7.18388 8.49553 7.24706 8.47059 7.32353 8.47059H8.1L7.09412 7.46471C7.04706 7.41765 7.02353 7.35882 7.02353 7.28824C7.02353 7.21765 7.05 7.15588 7.10294 7.10294C7.15588 7.05 7.21765 7.02353 7.28824 7.02353C7.35882 7.02353 7.42059 7.05 7.47353 7.10294L8.47059 8.1V7.32353C8.47059 7.24706 8.49553 7.18376 8.54541 7.13365C8.59553 7.08376 8.65882 7.05882 8.73529 7.05882C8.81176 7.05882 8.87506 7.08376 8.92518 7.13365C8.97506 7.18376 9 7.24706 9 7.32353V8.68235C9 8.77059 8.96918 8.84565 8.90753 8.90753C8.84565 8.96918 8.77059 9 8.68235 9H7.32353ZM3.31765 9C3.22941 9 3.15447 8.96918 3.09282 8.90753C3.03094 8.84565 3 8.77059 3 8.68235V7.32353C3 7.24706 3.02506 7.18376 3.07518 7.13365C3.12506 7.08376 3.18824 7.05882 3.26471 7.05882C3.34118 7.05882 3.40435 7.08376 3.45424 7.13365C3.50435 7.18376 3.52941 7.24706 3.52941 7.32353V8.1L4.53529 7.09412C4.58235 7.04706 4.64118 7.02353 4.71176 7.02353C4.78235 7.02353 4.84412 7.05 4.89706 7.10294C4.95 7.15588 4.97647 7.21765 4.97647 7.28824C4.97647 7.35882 4.95 7.42059 4.89706 7.47353L3.9 8.47059H4.67647C4.75294 8.47059 4.81624 8.49553 4.86635 8.54541C4.91624 8.59553 4.94118 8.65882 4.94118 8.73529C4.94118 8.81176 4.91624 8.87506 4.86635 8.92518C4.81624 8.97506 4.75294 9 4.67647 9H3.31765Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4067_25370",
    x: -655,
    y: -154,
    width: 1282,
    height: 325,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4067_25370"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4067_25370",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4067_25370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2061,
    fill: "white",
    transform: "translate(-774 -1027)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.27da25b32f56cdd3b4c002aebf729105.svg";
export { ForwardRef as ReactComponent };